(function () {
    function formatNumber(value) {
        try {
            return new Intl.NumberFormat().format(value);
        } catch (error) {
            return String(value);
        }
    }

    function formatMultiplier(value) {
        var number = parseFloat(value);

        if (isNaN(number)) {
            return '1';
        }

        if (Math.abs(number - Math.round(number)) < 0.000001) {
            return String(Math.round(number));
        }

        return number.toFixed(2).replace(/\.?0+$/, '');
    }

    function readVariants(badge) {
        var variantsNode = document.getElementById(badge.id + '-variants');

        if (!variantsNode) {
            return [];
        }

        try {
            return JSON.parse(variantsNode.textContent || '[]');
        } catch (error) {
            return [];
        }
    }

    function getProductScope(badge) {
        return badge.closest('.product-section') || badge.closest('.shopify-section') || document;
    }

    function getSelectedVariantId(scope, badge) {
        var checkedInput = scope.querySelector('input[name="id"]:checked');

        if (checkedInput && checkedInput.value) {
            return String(checkedInput.value);
        }

        var variantFields = scope.querySelectorAll('select[name="id"], input[name="id"]');

        for (var i = 0; i < variantFields.length; i += 1) {
            if (variantFields[i].value) {
                return String(variantFields[i].value);
            }
        }

        return String(badge.dataset.initialVariantId || '');
    }

    function getSelectedVariant(scope, badge, variants) {
        var variantId = getSelectedVariantId(scope, badge);

        if (!variantId) {
            return null;
        }

        for (var i = 0; i < variants.length; i += 1) {
            if (String(variants[i].id) === variantId) {
                return variants[i];
            }
        }

        return null;
    }

    function getQuantity(scope) {
        var selectors = [
            'input[name="quantity"]',
            '.quantity__input',
            '.js-qty__num',
            'input[type="number"][name*="quantity"]',
            'input[type="number"][id*="quantity"]'
        ];

        for (var i = 0; i < selectors.length; i += 1) {
            var fields = scope.querySelectorAll(selectors[i]);

            for (var j = 0; j < fields.length; j += 1) {
                var value = parseInt(fields[j].value, 10);

                if (!isNaN(value) && value > 0) {
                    return value;
                }
            }
        }

        return 1;
    }

    function calculateEntries(basePrice, divisor, multiplier, bonusEntries) {
        var rawEntries = basePrice / divisor;
        var baseEntries = Math.ceil(rawEntries);
        var entries = Math.floor(baseEntries * multiplier);

        if (entries < 1 && basePrice > 0) {
            entries = 1;
        }

        if (bonusEntries > 0) {
            entries += bonusEntries;
        }

        return entries;
    }

    function updateBadge(badge, variants) {
        var scope = getProductScope(badge);
        var variant = getSelectedVariant(scope, badge, variants);
        var quantity = getQuantity(scope);

        var divisor = parseFloat(badge.dataset.entryDivisor || '1') || 1;
        var multiplier = parseFloat(badge.dataset.multiplier || '1') || 1;
        var bonusEntries = parseFloat(badge.dataset.bonusEntries || '0') || 0;
        var overrideUnitPrice = badge.dataset.overrideUnitPrice !== '' ? parseFloat(badge.dataset.overrideUnitPrice || '0') : null;
        var showMultiplier = badge.dataset.showMultiplier === 'true';

        var basePrice = 0;

        if (overrideUnitPrice !== null && !isNaN(overrideUnitPrice) && overrideUnitPrice > 0) {
            basePrice = overrideUnitPrice * quantity;
        } else if (variant && typeof variant.price !== 'undefined') {
            basePrice = (parseInt(variant.price, 10) / 100) * quantity;
        }

        var entries = calculateEntries(basePrice, divisor, multiplier, bonusEntries);
        var noun = entries === 1 ? 'ENTRY' : 'ENTRIES';

        var countElement = badge.querySelector('.shared-sweeps-pdp-badge__count');
        var nounElement = badge.querySelector('.shared-sweeps-pdp-badge__noun');
        var multiplierElement = badge.querySelector('.shared-sweeps-pdp-badge__multiplier');

        if (countElement) {
            countElement.textContent = formatNumber(entries);
        }

        if (nounElement) {
            nounElement.textContent = noun;
        }

        if (showMultiplier && multiplierElement) {
            multiplierElement.textContent = formatMultiplier(multiplier) + '×';
            badge.setAttribute('aria-label', 'Earn ' + formatNumber(entries) + ' ' + noun.toLowerCase() + ', ' + formatMultiplier(multiplier) + 'x');
        } else {
            badge.setAttribute('aria-label', 'Earn ' + formatNumber(entries) + ' ' + noun.toLowerCase());
        }
    }

    function bindBadge(badge) {
        if (!badge || badge.dataset.sharedSweepsBound === 'true') {
            return;
        }

        badge.dataset.sharedSweepsBound = 'true';

        var scope = getProductScope(badge);
        var variants = readVariants(badge);
        var frameRequested = false;

        function queueUpdate() {
            if (frameRequested) {
                return;
            }

            frameRequested = true;

            requestAnimationFrame(function () {
                frameRequested = false;
                updateBadge(badge, variants);
            });
        }

        function delayedUpdate() {
            queueUpdate();
            setTimeout(queueUpdate, 80);
            setTimeout(queueUpdate, 180);
            setTimeout(queueUpdate, 360);
        }

        updateBadge(badge, variants);

        scope.addEventListener('change', delayedUpdate, true);
        scope.addEventListener('input', delayedUpdate, true);

        scope.addEventListener('click', function (event) {
            var trigger = event.target.closest(
                '.js-qty__adjust, .quantity__button, .quantity-selector__button, .qty__button, [data-quantity-button], [data-qty-button]'
            );

            if (trigger) {
                delayedUpdate();
            }
        }, true);

        document.addEventListener('variant:change', delayedUpdate, true);
        document.addEventListener('product:variant-change', delayedUpdate, true);
    }

    function init(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var badges = scope.querySelectorAll('[data-shared-sweeps-pdp-badge]');

        badges.forEach(bindBadge);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init(document);
        });
    } else {
        init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });

    if (window.MutationObserver) {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (!node || node.nodeType !== 1) {
                        return;
                    }

                    if (node.matches && node.matches('[data-shared-sweeps-pdp-badge]')) {
                        bindBadge(node);
                        return;
                    }

                    init(node);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();